"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMicrosoftAppButton = exports.ButtonText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const GetMicrosoftAppButton_module_css_1 = __importDefault(require("./GetMicrosoftAppButton.module.css"));
const GetMicrosoftAppButton_svg_1 = __importDefault(require("./GetMicrosoftAppButton.svg"));
const GetMicrosoftAppButtonLight_svg_1 = __importDefault(require("./GetMicrosoftAppButtonLight.svg"));
const GetMicrosoftAppButtonDark_svg_1 = __importDefault(require("./GetMicrosoftAppButtonDark.svg"));
const react_intl_1 = require("react-intl");
const web_i18n_1 = require("@snapchat/web-i18n");
const messageLoader_1 = require("../../i18n/messageLoader");
const web_env_1 = require("@snapchat/web-env");
/**
 * The text of the GetMicrosoftAppButton to support localization
 * Separated it from the component for translation
 */
function ButtonText() {
    return ((0, jsx_runtime_1.jsx)("span", { className: GetMicrosoftAppButton_module_css_1.default.buttonTextContainer, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "1PLQmO", description: "The text of badge indicates user can click on it and navigates to Microsoft store to download the app", defaultMessage: "<p>Get it from</p><t>Microsoft</t>", values: {
                p: (chunks) => (0, jsx_runtime_1.jsx)("p", { className: GetMicrosoftAppButton_module_css_1.default.buttonText, children: chunks }),
                t: (chunks) => (0, jsx_runtime_1.jsx)("span", { className: GetMicrosoftAppButton_module_css_1.default.microsoftName, children: chunks }),
            } }) }));
}
exports.ButtonText = ButtonText;
/**
 * Get Microsoft App button, redirects Microsoft App website
 */
function GetMicrosoftAppButton({ onClick, theme = "dark", pageKey, isCompact, localeProps, }) {
    // The cid is our app campaign code for analytics purposes.
    // If the user clicks the app badge,
    // this value will be passed to analytics
    // and will be available to you in your Microsoft Partner Center reports.
    // https://github.com/microsoft/app-store-badge#usage
    const appUrl = `https://apps.microsoft.com/store/detail/snapchat/9PF9RTKMMQ69?cid=${pageKey.toLowerCase()}`;
    function clickDownloadMicrosoftApp() {
        onClick?.();
        (0, web_env_1.getWindow)()?.open(appUrl)?.focus();
    }
    const intl = (0, react_intl_1.useIntl)();
    const isLight = theme === "light";
    const { locale, messages } = (0, web_i18n_1.useLocale)({
        defaultLocale: localeProps,
        loadMessages: messageLoader_1.loadMessages,
    });
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: (0, clsx_1.default)(GetMicrosoftAppButton_module_css_1.default.downloadMicrosoftAppButton, {
            [GetMicrosoftAppButton_module_css_1.default.whiteButton]: isLight,
            [GetMicrosoftAppButton_module_css_1.default.localizedDownloadMicrosoftAppButton]: !isCompact,
        }), onClick: clickDownloadMicrosoftApp, "data-testid": `${pageKey}_${isLight ? "Light" : "Dark"}GetMicrosoftAppButton`, title: intl.formatMessage({
            id: "0yjej6",
            defaultMessage: "Get Snapchat App in Microsoft Store",
            description: "Title of the button",
        }), children: isCompact ? (isLight ? ((0, jsx_runtime_1.jsx)(GetMicrosoftAppButtonLight_svg_1.default, {})) : ((0, jsx_runtime_1.jsx)(GetMicrosoftAppButtonDark_svg_1.default, {}))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(GetMicrosoftAppButton_svg_1.default, {}), localeProps ? ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, messages: messages, defaultLocale: web_i18n_1.Locale.enUS, children: (0, jsx_runtime_1.jsx)(ButtonText, {}) })) : ((0, jsx_runtime_1.jsx)(ButtonText, {}))] })) }));
}
exports.GetMicrosoftAppButton = GetMicrosoftAppButton;
//# sourceMappingURL=GetMicrosoftAppButton.js.map